/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PuntoDiRaccoltaCreateDTO
 */
export interface PuntoDiRaccoltaCreateDTO {
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaCreateDTO
     */
    nome?: string;
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaCreateDTO
     */
    regioneId?: string;
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaCreateDTO
     */
    provinciaId?: string;
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaCreateDTO
     */
    comuneId?: string;
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaCreateDTO
     */
    nazioneId?: string;
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaCreateDTO
     */
    regione?: string;
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaCreateDTO
     */
    provincia?: string;
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaCreateDTO
     */
    comune?: string;
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaCreateDTO
     */
    localita?: string;
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaCreateDTO
     */
    cap?: string;
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaCreateDTO
     */
    indirizzo?: string;
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaCreateDTO
     */
    numeroCivico?: string;
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaCreateDTO
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaCreateDTO
     */
    telefono?: string;
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaCreateDTO
     */
    cellulare?: string;
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaCreateDTO
     */
    note?: string;
    /**
     * 
     * @type {number}
     * @memberof PuntoDiRaccoltaCreateDTO
     */
    capienzaMassima?: number;
    /**
     * 
     * @type {number}
     * @memberof PuntoDiRaccoltaCreateDTO
     */
    latitudine?: number;
    /**
     * 
     * @type {number}
     * @memberof PuntoDiRaccoltaCreateDTO
     */
    longitudine?: number;
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaCreateDTO
     */
    informazioniDiAccesso?: string;
}

/**
 * Check if a given object implements the PuntoDiRaccoltaCreateDTO interface.
 */
export function instanceOfPuntoDiRaccoltaCreateDTO(value: object): value is PuntoDiRaccoltaCreateDTO {
    return true;
}

export function PuntoDiRaccoltaCreateDTOFromJSON(json: any): PuntoDiRaccoltaCreateDTO {
    return PuntoDiRaccoltaCreateDTOFromJSONTyped(json, false);
}

export function PuntoDiRaccoltaCreateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): PuntoDiRaccoltaCreateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'nome': json['nome'] == null ? undefined : json['nome'],
        'regioneId': json['regioneId'] == null ? undefined : json['regioneId'],
        'provinciaId': json['provinciaId'] == null ? undefined : json['provinciaId'],
        'comuneId': json['comuneId'] == null ? undefined : json['comuneId'],
        'nazioneId': json['nazioneId'] == null ? undefined : json['nazioneId'],
        'regione': json['regione'] == null ? undefined : json['regione'],
        'provincia': json['provincia'] == null ? undefined : json['provincia'],
        'comune': json['comune'] == null ? undefined : json['comune'],
        'localita': json['localita'] == null ? undefined : json['localita'],
        'cap': json['cap'] == null ? undefined : json['cap'],
        'indirizzo': json['indirizzo'] == null ? undefined : json['indirizzo'],
        'numeroCivico': json['numeroCivico'] == null ? undefined : json['numeroCivico'],
        'email': json['email'] == null ? undefined : json['email'],
        'telefono': json['telefono'] == null ? undefined : json['telefono'],
        'cellulare': json['cellulare'] == null ? undefined : json['cellulare'],
        'note': json['note'] == null ? undefined : json['note'],
        'capienzaMassima': json['capienzaMassima'] == null ? undefined : json['capienzaMassima'],
        'latitudine': json['latitudine'] == null ? undefined : json['latitudine'],
        'longitudine': json['longitudine'] == null ? undefined : json['longitudine'],
        'informazioniDiAccesso': json['informazioniDiAccesso'] == null ? undefined : json['informazioniDiAccesso'],
    };
}

export function PuntoDiRaccoltaCreateDTOToJSON(value?: PuntoDiRaccoltaCreateDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'nome': value['nome'],
        'regioneId': value['regioneId'],
        'provinciaId': value['provinciaId'],
        'comuneId': value['comuneId'],
        'nazioneId': value['nazioneId'],
        'regione': value['regione'],
        'provincia': value['provincia'],
        'comune': value['comune'],
        'localita': value['localita'],
        'cap': value['cap'],
        'indirizzo': value['indirizzo'],
        'numeroCivico': value['numeroCivico'],
        'email': value['email'],
        'telefono': value['telefono'],
        'cellulare': value['cellulare'],
        'note': value['note'],
        'capienzaMassima': value['capienzaMassima'],
        'latitudine': value['latitudine'],
        'longitudine': value['longitudine'],
        'informazioniDiAccesso': value['informazioniDiAccesso'],
    };
}

